import { ReactNode } from 'react';

import { AppointmentPractitioner } from '@dreryk/egabinet-appointment-frontend-api';

import { Translate } from '@dreryk/react-common';
import { appendTestableElementAttributes, StrongText } from '@dreryk/react-components';

import { createMedicalRoleVisitor } from '~libs.shared.account';
import { PractitionerSafePresenter } from '~libs.desktop.shared.practitioner-safe-presenter';

import { StyledPractitionerResourceLabelContent } from './PractitionerResourceLabelContent.styled';
import { DoctorSpecialties } from './DoctorSpecialties';
import { ParamedicProfession } from './ParamedicProfession';

export const PractitionerResourceLabelContent = (resource: AppointmentPractitioner): ReactNode => {
   return (
      <PractitionerSafePresenter practitioner={resource} testId={'practitioner'} withIdentification>
         {({ displayName, testId }) => (
            <StyledPractitionerResourceLabelContent {...appendTestableElementAttributes(testId)}>
               {displayName ? (
                  <StrongText testId={'displayName'}>
                     <Translate>{displayName}</Translate>
                  </StrongText>
               ) : null}
               {createMedicalRoleVisitor(resource)({
                  visitDoctor: ({ specialtyNames }) => <DoctorSpecialties specialties={specialtyNames} />,
                  visitParamedic: ([paramedicProfession]) => <ParamedicProfession profession={paramedicProfession} />,
                  visitUnknown: () => null,
               })}
            </StyledPractitionerResourceLabelContent>
         )}
      </PractitionerSafePresenter>
   );
};
